export default "__VITE_ASSET__W2jDSGFd__"